import { StockOrderHead } from "../components";
import { NoticesAdminContent } from "../components/notices-admin-content";

export function NoticesAdminPage() {
  return (
    <>
      <StockOrderHead
        StockOrderBreadCrumbsProps={{
          home: {
            title: "Home",
            url: "/admin/material/order",
          },
          className: "lg:h-[200px]",
          pageTitles: [
            {
              name: "Settings",
              url: "/admin/material/settings/notices",
            },
            {
              name: "Notices",
              url: "/admin/material/settings/notices",
            },
          ],
        }}
      />
      <div className="p-8">
        <NoticesAdminContent />
      </div>
    </>
  );
}
